import type { AssetProject, AssetProjectDto } from "../../domain/asset";
import { apiClientJSONAssets } from "../apiClient";

/** Raw API response type for AssetProject (dates as strings before conversion) */
interface AssetProjectRaw extends Omit<AssetProject, "startDate" | "endDate"> {
  startDate: string;
  endDate: string;
}

export const getAssetProjects = (
  cityId: number,
  onlyActive: boolean = false
): Promise<AssetProject[]> => {
  return apiClientJSONAssets
    .get("/project", {
      params: {
        cityId,
        minEndDate: onlyActive ? new Date() : undefined,
      },
    })
    .then((r) => r.data)
    .then((items: AssetProjectRaw[]) =>
      items.map<AssetProject>((i) => ({
        ...i,
        startDate: new Date(i.startDate),
        endDate: new Date(i.endDate),
      }))
    );
};

export const createAssetProject = (dto: AssetProjectDto): Promise<void> => {
  return apiClientJSONAssets.post("/project", dto);
};

export const updateAssetProject = (
  projectId: number,
  dto: AssetProjectDto
): Promise<void> => {
  return apiClientJSONAssets.patch(`/project/${projectId}`, dto);
};

export const deleteAssetProject = (projectId: number): Promise<void> => {
  return apiClientJSONAssets.delete(`/project/${projectId}`);
};
